/* eslint-disable no-unused-vars */
import React, { Component } from "react";
import Alerts from "./Alerts";
import Popup from "reactjs-popup";
import ApiRequest from "../../libs/request";
import FeedFilters from "./FeedFilters";
import { params } from "../../libs/functions";
import SettingsPanel from "./SettingsPanel";
import SearchResults from "./SearchResults";
import MessagesPanel from "./MessagesPanel";
import SearchModal from "./SearchModal";
import MessagesPanelModal from "./MessagesPanelModal";
import { FaTimes, FaTimesCircle, FaBars, FaSearch } from "react-icons/fa";
import { IoMdNotificationsOutline } from "react-icons/io";
import { FiMessageCircle } from "react-icons/fi";
import { IoSearchOutline } from "react-icons/io5";

import { RiMessage3Line } from "react-icons/ri";

class Nav extends Component {
  constructor(props) {
    super(props);
    this.state = { 
      alerts: 0, 
      search_results: {},
      sidebarOpen: false,
      searchOpen: false,
      isMobile: window.innerWidth <= 768,
      messagesModalOpen: false,
      searchModalOpen: false
    };
  }

  componentDidMount() {
    // Listen for state changes from FeedNav to keep icon in sync
    window.addEventListener('feedNavStateChange', this.handleFeedNavStateChange);
    // Listen for window resize to detect mobile/desktop
    window.addEventListener('resize', this.handleResize);
    // Get alert count
    this.getAlertCount();
  }

  componentWillUnmount() {
    window.removeEventListener('feedNavStateChange', this.handleFeedNavStateChange);
    window.removeEventListener('resize', this.handleResize);
  }

  handleResize = () => {
    const isMobile = window.innerWidth <= 768;
    if (isMobile !== this.state.isMobile) {
      this.setState({ isMobile });
    }
  }

  handleFeedNavClosed = () => {
    this.setState({ sidebarOpen: false });
  }

  handleFeedNavStateChange = (e) => {
    // Sync Nav's icon state with FeedNav's state
    this.setState({ sidebarOpen: e.detail.open });
  }

  toggleSidebar = () => {
    this.setState({ sidebarOpen: !this.state.sidebarOpen });
    // Dispatch event for FeedNav to listen to
    window.dispatchEvent(new CustomEvent('toggleSidebar'));
  }

  toggleSearch = () => {
    if (this.state.isMobile) {
      // Open search modal on mobile
      this.setState({ searchModalOpen: true });
    } else {
      // Toggle search open on desktop
      this.setState(
        (prev) => ({ searchOpen: !prev.searchOpen }),
        () => {
          setTimeout(() => {
            document.getElementById("desktop-search-input")?.focus();
          }, 0);
        }
      );
    }
  }

  render() {
    if (this.props.partialNav) {
      return this.renderPartialNav();
    } else {
      return this.renderFullNav();
    }
  }

  renderPartialNav() {
    return (
      <React.Fragment>
        <div className=" header main ">
          <div className="container">
            <div
              className="logo-feed"
              onClick={() => {
                location.href = "/";
              }}
            ></div>
            {/* <div className="settings-pop" style={{ float: "right" }}>
              <Popup
                trigger={(open) => (
                  <div className="settings" title="Settings" />
                )}
                position="bottom center"
                closeOnDocumentClick
              >
                <div className="settings-panel">
                  <div className="label" onClick={this.handleSignout.bind(this)}>
                    <img src="/images/logout.png" />
                    Logout
                  </div>
                </div>
              </Popup>
            </div> */}
          </div>
        </div>
      </React.Fragment>
    );
  }
  renderFullNav() {
    if (this.props.user == null) {
      return <div />;
    }
    var _alerts_count = [];
    if (this.state.alerts == 0) {
      _alerts_count.push(<div key="alerts-count" />);
    } else {
      _alerts_count.push(
        <div key="alerts-count" className="alerts-count">
          {this.state.alerts}
        </div>
      );
    }
    var _searchPreviews = "";
    var _showSearch = "none";
    var _avatar_image = this.props.user?.profile_photo != null ? this.props.user?.profile_photo : "/images/placeholder.png";
    if (this.state.search_results.length > 0) {
      _showSearch = "block";
      _searchPreviews = (
        <SearchResults
          user={this.props.user}
          results={this.state.search_results}
        />
      );
    }

    return (
      <React.Fragment>
        <div className="header-wrapper">
        <div className="header main main-header">
          {/* Hamburger Button - Mobile */}
          <div className="nav-hamburger">
            <button
              className="hamburger-btn-nav"
              onClick={this.toggleSidebar}
              title="Menu"
            >
              {this.state.sidebarOpen ? <FaTimes /> : <FaBars />}
            </button>
          </div>

          <div className="nav-container">
            <div className="nav-left-section">
              <div
                className="logo-feed"
                onClick={() => {
                  location.href = "/";
                }}
              ></div>
              
              {/* Desktop Search - Only on desktop */}
              {!this.state.isMobile && (
                <input
                  type="text"
                  placeholder="Search"
                  id="desktop-search-input"
                  className="nav-search desktop-nav-search"
                  autoComplete="off"
                  defaultValue={params("search")}
                  onFocus={this.handleFocusClick.bind(this)}
                  onKeyUp={this.handleSearch.bind(this)}
                />
              )}
              
            

              <div className="search-preview" style={{ display: _showSearch }}>
                <FaTimesCircle className="close-search" onClick={() => {
                  this.setState({
                    search_results: {}
                  })
                  const desktopInput = document.getElementById("desktop-search-input");
                  const mobileInput = document.getElementById("mobile-search-input");
                  if (desktopInput) desktopInput.value = "";
                  if (mobileInput) mobileInput.value = "";
                }} />
                <div style={{ marginTop: "20px" }}>
                  {_searchPreviews}
                </div>
              </div>
              {/* <div className="filter-options">
                <Popup
                  trigger={(open) => (
                    <img src="/images/options.png" className="options-btn" />
                  )}
                  position="bottom center"
                  closeOnDocumentClick
                >
                  <FeedFilters />
                </Popup>
              </div> */}
            </div>

                  <div className="nav-right-content">
                      {/* Search Icon Toggle - Mobile */}
                      <div className="">

              <button
                className="s-search"
                onClick={this.toggleSearch}
                title="Search"
                >
               <IoSearchOutline size={26} color="#ff5e3a"/>
              </button>
                </div>
                  
                    {/* <div className="alerts-control">
                      <Popup
                        trigger={(open) => (
                          <div className="header-messages" style={{ right: '7px' }} title="Notifications">
                            <div >
                              {_alerts_count}
                            </div>
                           
                            <IoMdNotificationsOutline size={28} color="#ff5e3a" className=""/>
                          </div>
                        )}
                        position="bottom right"
                        closeOnDocumentClick
                      >
                        <Alerts
                          user={this.props.user}
                          onAlertsChange={this.getAlertCount.bind(this)}
                        />
                      </Popup>
                    </div> */}

                    {/* <a href="/messages" title="New Message">
                      <div className="header-messages">
                        <i className="fas fa-
                        comment-dots header-msg-icon"></i>
                      </div>
                    </a> */}
                    <div className="messages-control">
                      <button 
                        className="header-messages-btn" 
                        onClick={() => this.setState({ messagesModalOpen: true })}
                        style={{ cursor: 'pointer' }} 
                        title="Messages"
                      >
                        <div className="header-messages">
                          <RiMessage3Line size={28} color="#ff5e3a" />
                        </div>
                      </button>
                    </div>
                    <div className="settings-pop">
                      <Popup
                        trigger={(open) => (
                          <div className="user-avatar">
                            <img src={_avatar_image} className="header-avatar" />
                            {/* <i className="fas fa-angle-down avatar-angleDownIcon"></i> */}
                          </div>
                        )}
                        position="bottom right"
                        closeOnDocumentClick
                      >
                        <SettingsPanel user={this.props.user} userImage={_avatar_image} userName={this.props.user?.first_name ? `${this.props.user?.first_name} ${this.props.user?.last_name}` : "Username"} />
                      </Popup>
                    </div>
                  </div>
          </div>
        </div>

        {/* Search Modal - Mobile Only */}
        <SearchModal 
          isOpen={this.state.searchModalOpen}
          onClose={() => this.setState({ searchModalOpen: false })}
          searchInput=""
          onSearchChange={this.handleSearch.bind(this)}
          onClearSearch={() => this.setState({ search_results: {} })}
          searchResults={this.state.search_results}
        />
        
        {/* Messages Modal */}
        {this.state.messagesModalOpen && (
          <MessagesPanelModal 
            user={this.props.user} 
            onClose={() => this.setState({ messagesModalOpen: false })}
          />
        )}
        </div>
      </React.Fragment>
    );
  }

  handleSearch(e) {
    var _obj = e;
    // if (_obj.keyCode != 13) {
    //   return;
    // }
    if (_obj.target.value.length > 2) {
      var _type = params("type") ? params("type") : 1;
      var api = new ApiRequest(
        "get",
        "/user/search-friends?search=" +
        _obj.target.value
      );
      api.send({}, (response) => {
        this.setState({ 
          search_results: { 
            users: response.data.users.data || [],
            companies: response.data.companies ? response.data.companies.data : [],
            projects: response.data.projects ? response.data.projects.data : []
          } 
        });
      });
    } else {
      this.setState({ search_results: {} });
    }
    //location.href = "/?type=" + _type + "&search=" + _obj.target.value;
  }

  handleFocusClick() {
    var api = new ApiRequest(
      "get",
      "/user/search-friends?search=a"
    );
    api.send({}, (response) => {
      if (response.data.users.data.length > 0) {
        // attach first 10 results
        const _results = response.data.users.data.slice(0, 10);
        this.setState({ search_results: _results });
      }
    });
  }

  handleSignout() {
    var api = new ApiRequest("delete", "/sessions/" + this.props.user?.id);
    api.send({}, () => {
      localStorage.removeItem("gorilla-token");
      window.location.href = "/";
    });
  }

  getAlertCount() {
    if (Object.keys(this.props.user).length === 0) {
      return;
    }
    var api = new ApiRequest("get", "/user/get-notifictions");
    api.send({}, (response) => {
      this.setState({
        alerts:
          response.data.notifications ? response.data.notifications.filter((a) => a.status == "unread").length : 0
      });
    });
  }
}

export default Nav;
